import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { promise } from 'protractor';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EcommerceService {
  public categoriesSubject = new BehaviorSubject<any[]>([]);
  categories$: Observable<any[]> = this.categoriesSubject.asObservable();

  public currencySubject = new BehaviorSubject<any[]>(null);
  currency$: Observable<any[]> = this.currencySubject.asObservable().pipe(map(res=>{
    if(!res ){
      this.executeGetCurrency();
    }
    return res?res:[];
  }));

  public cultureSubject = new BehaviorSubject<any[]>(null);
  culture$: Observable<any[]> = this.cultureSubject.asObservable().pipe(map(res=>{
    if(!res){
      this.executeGetCultures();
    }
    return res?res:[];
  }))
  

  activeCatSubject = new BehaviorSubject<number[]>([]);
  activeCat$: Observable<number[]> = this.activeCatSubject.asObservable();
  breadCrumbCatSubject = new BehaviorSubject<number[]>([]);
  breadCrumbCat$: Observable<number[]> = this.breadCrumbCatSubject.asObservable();

  categoryProductsSubject = new BehaviorSubject<number[]>([]);
  categoryProducts$: Observable<number[]> = this.categoryProductsSubject.asObservable();

  mapsJS: any;
  isScriptReady: Subject<any> = new Subject<any>();

  public subCategoriesSubject = new BehaviorSubject<any[]>([]);
  subCategories$: Observable<any[]> = this.subCategoriesSubject.asObservable();


  cartItemsChanged: BehaviorSubject<any> = new BehaviorSubject<any>({});


  isNewItem: boolean = false;
  isNewCartItemChanged: Subject<boolean> = new Subject<boolean>();


  constructor(private http: HttpClient, private datePipe: DatePipe) {
    this.getCultures().subscribe()
  

    this.isNewCartItemChanged.subscribe((value) => {
      this.isNewItem = value;
    });

  }
  public getBreadCrumb(id){
    return this.http.get(`/Categories/GetCategoryBreadCrumb/${id}`).pipe(
      tap((res: any[]) => res && this.breadCrumbCatSubject.next(res)),
    );
  }
  public getCategoryBreadCrumb(id){
    return this.http.get(`/Categories/GetCategoryBreadCrumb/${id}`) 
  }
  public getCatsByBrandId(id){
return this.http.get(`/brands/GetCategoriesByBrandId/${id}`)
  }
public getCategoriesByParams(category: any[],categoryTypeId:number,activeId?:number,orderBy?:number,sortType?:number){
  return this.http.post(`/GeneralProduct/GetCategoriesNavigator`, {parentIds:[category],categoryTypeId:categoryTypeId,activeId:activeId,orderBy:orderBy?orderBy:2,sortType:sortType?sortType:1}).pipe(
    tap((res: any[]) => res && this.subCategoriesSubject.next(res)),
  );
}
  public getCategoryById(id){
    return this.http.get(`/Categories/GetCategoriesById/${id}` )
  }

  public getCategories(categories: any[]) {
    return this.http.post(`/Categories/GetCategoriesByIds`, categories).pipe(
      tap((res: any[]) => res && this.categoriesSubject.next(res)),
    );
  }

  public getCategoriesByIds(categories: any[],categoryTypeId:number,activeId?) {
    return this.http.post(`/GeneralProduct/GetCategoriesNavigator`, {parentIds:categories,categoryTypeId:categoryTypeId,activeId:activeId}).pipe(
      tap((res: any[]) => res && this.categoriesSubject.next(res)),
    );
  }
public getProductsByCategoryId(data){
  return this.http.post(`/GeneralProduct/GetProductByCategoryId`,data).pipe(
    tap((res: any[]) => res && this.categoryProductsSubject.next(res)),
  );
}
  public GetCProductsByCategoryId(id) {
    return this.http.get(`/catalog/GetCategoryProductsById/` + id);
  }
  public getProductBySlug(slug){
    return this.http.get(`/product/GetProductBySlug/${slug}`)
  }

  public addToCart(data) {
    return this.http.post(`/cart/add-item`, data);
  }

  public getCartList(cartType) {
    return this.http.get(`/cart/cart-list/${cartType}`);
  }

  public removeItem(id) {
    return this.http.post(`/cart/remove-item/1`, id);
  }

  public getStatesByCountryId(id) {
    return this.http.get(`/states-provinces/states?countryId=` + id);
  }

  public saveAddress(data) {
    return this.http.post(`/UserAdress/Create`, data);
  }
  public shippingOrder(data) {

    return this.http.post(`/checkout/shipping-order`, data);
  }

  public shippingDetails() {
    return this.http.get(`/checkout/shipping-details`);
  }

  public updateTaxAndShipping(data) {
    return this.http.post(`/checkout/update-tax-and-shipping-prices`, data);
  }

  public proceedToCheckout(cartType) {
    return this.http.get(`/checkout/payment/` + cartType);
  }
  public getCurrencies() {
    return this.http.get(`/currency/get-all-currencies`).pipe(
      tap((res: any) => res && this.currencySubject.next(res)),
    );
  }

  getpaymentProviders() {
    return this.http.get(`/payments-providers`);
  }

  PaymentMEPS(cartType, settings) {
    return this.http.get(`/PaymentMEPS/hostedCheckout?CartType=` + cartType).pipe(
      tap((res) => this.addScript(res, settings))
    );
  }

  mepsHostedCheckout(orderId, result) {
    return this.http.get(`/PaymentMEPS/hostedCheckout/${orderId}/${result}`);
  }

  sendEmail(order, templateId, emailReceviers: string[], name?) {
    var items = this.getItems(order);

    const notificationAPIData = {
      NotificationType: 3,
      SendVia: 2,
      SendValue: emailReceviers,
      Severity: 1,
      emailSenderVM: {
        Emails: emailReceviers,
        TemplateId: templateId,
        isHtml: true, attachment: null,
        Params: [

          { Param: '[Name]', Value: order.customerName || "" },
          { Param: '[Date]', Value: this.datePipe.transform(new Date().toLocaleDateString(), 'dd/MM/yyyy') },
          { Param: '[InvoiceNo]', Value: order.id },
          { Param: '[OrderTotal]', Value: order.orderTotalString },
          { Param: '<tr><td>[Items]</td></tr>', Value: items },
          { Param: '[Email]', Value: order.customerEmail || "" },
          { Param: '[Phone]', Value: order.shippingAddress.zipCode + order.shippingAddress.phone || '' },

        ]
      }
    }

    return this.http.post(`/Notification/send`, notificationAPIData)
      .pipe();
  }

  getOrder(orderId: number): any {
    return this.http.get<any>(`/orders/${orderId}`);
  }

  countryCode() {
    return this.http.get('https://gist.githubusercontent.com/anubhavshrimal/75f6183458db8c453306f93521e93d37/raw/f77e7598a8503f1f70528ae1cbf9f66755698a16/CountryCodes.json');
  }

  addScript(data, settings) {
    const oldJs = document.getElementsByTagName("script");

    for (let index = 0; index < oldJs.length; index++) {
      const element = oldJs[index];
      const getName = element.getAttribute("name");
      if (getName && getName.indexOf("mepsJS") !== -1) {
        document.head.removeChild(element);
        index = index - 1;
      }
    }

    var js = data.checkoutJsUrl;
    this.mapsJS = document.createElement("script");
    this.mapsJS.setAttribute("name", "mepsJS");
    this.mapsJS.setAttribute("src", js);
    this.mapsJS.setAttribute("data-error", settings.errorPage);
    this.mapsJS.setAttribute("data-cancel", settings.cancelPage);
    this.mapsJS.setAttribute("data-complete", settings.successPage);
    document.head.appendChild(this.mapsJS);
    data.script = this.mapsJS;
    this.ScriptReady(data);

  }

  public ScriptReady(data) {
    this.isScriptReady.next(data);
  }

  getItems(order) {
    var items = '';

    order.orderItems.forEach(item => {
      items += `
      <tr>
       <td>${item.id}</td>
       <td>${item.productName}</td>
       <td>${item.totalString}</td>
      </tr>
      `
    });

    return items;
  }

  public getCultures() {
    return this.http.get(`/General/GetCultureBySiteId`)
      .pipe(
        tap((res: any) => res && this.cultureSubject.next(res)),
      );
  }
public executeGetCultures(){
  this.getCultures().subscribe();
}
  public executeGetCurrency(){
    this.getCurrencies().subscribe();
  }
  public editUserCurrencyCulture(data) {
    return this.http.put(`/users/EditUserCurrency`, data);
  }

  public isNewCartItem() {
    this.isNewCartItemChanged.next(this.isNewItem);
    this.isNewItem = false;
  }


  public GetProductByCategory(request: any) {
    // return this.httpClient.get(`/BolgArchive/GetPosts/1/1/1000/${ids}`);
    return this.http.post<any>("/GeneralProduct/GetProductsbyCategoryId",request);


  }
}
